(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["o2-footer"]) return;
  try {
    
document.addEventListener('pointerover',event=>{const menu=event.target.closest('[data-o2-policy-menu]');if(menu&&event.pointerType==='mouse')menu.open=true;});
document.addEventListener('pointerout',event=>{const menu=event.target.closest('[data-o2-policy-menu]');if(menu&&event.pointerType==='mouse'&&!menu.contains(event.relatedTarget)&&!menu.contains(document.activeElement))menu.open=false;});
document.addEventListener('focusout',event=>{const menu=event.target.closest('[data-o2-policy-menu]');if(menu&&!menu.contains(event.relatedTarget)&&!menu.matches(':hover'))menu.open=false;});
document.addEventListener('keydown',event=>{if(event.key!=='Escape')return;document.querySelectorAll('[data-o2-policy-menu][open]').forEach(menu=>{menu.open=false;if(menu.contains(document.activeElement))menu.querySelector('summary').focus();});});
document.addEventListener('click',event=>{const summary=event.target.closest('[data-o2-policy-menu] > summary');if(summary&&event.pointerType==='mouse'){event.preventDefault();summary.parentElement.open=true;}document.querySelectorAll('[data-o2-policy-menu][open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["o2-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',(event)=>{const button=event.target.closest('[data-o2-switch]');if(!button)return;const home=button.closest('[data-o2-home]');home.querySelectorAll('[data-o2-slide]').forEach(slide=>{slide.hidden=slide.dataset.o2Slide!==button.dataset.o2Switch});home.querySelectorAll('[data-o2-switch]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["o2-product"]) return;
  try {
    
document.addEventListener('click',(event)=>{const thumb=event.target.closest('[data-o2-photo]');if(thumb){const root=thumb.closest('[data-o2-product]');const img=root.querySelector('.o2-gallery-featured');img.removeAttribute('srcset');img.src=thumb.dataset.o2Photo;img.alt=thumb.dataset.o2Alt;root.querySelectorAll('[data-o2-photo]').forEach(item=>item.setAttribute('aria-pressed',String(item===thumb)));}const zoom=event.target.closest('[data-o2-zoom]');if(zoom){const root=zoom.closest('[data-o2-product]');const box=root.querySelector('[data-o2-lightbox]');const holder=box.querySelector('[data-o2-zoom-image]');holder.replaceChildren(root.querySelector('.o2-gallery-featured').cloneNode(true));box.showModal();}const close=event.target.closest('[data-o2-close]');if(close)close.closest('dialog').close();if(event.target.matches('[data-o2-lightbox]'))event.target.close();});
document.addEventListener('change',(event)=>{if(!event.target.matches('[data-o2-variant]'))return;const select=event.target;const root=select.closest('[data-o2-product]');const option=select.selectedOptions[0];root.querySelector('[data-o2-price]').textContent=option.dataset.price;const add=root.querySelector('[data-o2-add]');add.disabled=option.dataset.available!=='true';add.textContent=add.disabled?'Sold out':'Add to bag';const url=new URL(location.href);url.searchParams.set('variant',select.value);history.replaceState({},'',url);});

  } catch(e) { console.error(e); }
})();
})();
